<template>
  <div>
    <div :class="classes" :style="styleValue">
      <textarea
        ref="textarea"
        v-model="text"
        :rows="rows"
        :placeholder="placeholder"
        :style="styleArea"
        @focus="focuStat = true"
        @blur="focuStat = false"
      ></textarea>
      <span class="c-caption-length">
        <ins :class="warnClass">{{ len }}</ins
        >/{{ max }}
      </span>
    </div>
    <span v-if="!validate && isEmpty(value)" class="g-error-text">内容不能为空</span>
    <span v-else-if="!validate" class="g-error-text">超过了字符上限</span>
  </div>
</template>
<script>
import { getByteLen, isEmpty } from '@/common/js/utils'
export default {
  name: 'ctextarea',
  props: {
    value: {
      type: String
    },
    placeholder: {
      type: String
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    width: {
      type: [Number, String]
    },
    max: {
      type: Number
    },
    rows: {
      type: Number
    },
    bc: {
      type: Boolean,
      default() {
        return false
      }
    },
    charset: {
      type: String,
      default() {
        return 'gb2312'
      }
    },
    overflow: {
      type: Boolean,
      default: true
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    text: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    styleValue() {
      return {
        width: `${this.width}px`
      }
    },
    styleArea() {
      return this.overflow ? { overflow: 'hidden' } : ''
    },
    len() {
      let charLen = 2
      if (this.charset === 'utf-8') charLen = 3
      else if (this.charset === 'init') charLen = 1
      return this.bc ? Math.ceil(getByteLen(this.text) / charLen) : getByteLen(this.text, charLen)
    },
    classes() {
      return [
        'c-caption',
        {
          'c-cation-focus': this.focuStat
        }
      ]
    },
    warnClass() {
      return {
        'c-error': this.len > this.max
      }
    },
    validate() {
      return this.verify ? !(isEmpty(this.value) || this.len > this.max) : true
    }
  },
  methods: {
    isEmpty,
    focus() {
      this.$refs.textarea.focus()
    }
  },
  data() {
    return {
      focuStat: null
    }
  }
}
</script>
<style lang="scss" scoped>
.c-caption {
  width: 100%;
  position: relative;
  padding: 8px 8px 6px 8px;
  text-align: right;
  display: inline-block;
  border: solid 1px #dcdee2;
  border-radius: 4px;

  textarea {
    display: block;
    width: 100%;
    background-color: #fff;
    background-image: none;
    color: #515a6e;
    border: 0;
    // overflow hidden
    resize: none;
    outline: 0;
  }

  &:hover {
    border-color: #57a3f3;
  }

  .c-caption-length {
    color: #8e8e8e;

    .c-error {
      color: #ff4900;
    }
  }
}

.c-cation-focus {
  border-color: #57a3f3;
  box-shadow: 0 0 4px 0 #67affb;
}
</style>
